export default __webpack_public_path__ + "static/media/asrarizwan.3820a6a9.jpg";